import { Button, Col, Flex, Form, Input, Row, Select, message } from 'antd';
import { useContext, useEffect, useState } from 'react';
import { apiBasePath, sessionStorageKey_session } from '../../utils/constants';
import axios from 'axios';
import { ArrowLeftOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
// import { md5Crypt } from '../../utils/cryptMd5';
import { allowOnlyNumbers, cleanBusinessNameSuffixes, valueToUpperCase, withTrimmedForm } from '../../utils/utils';
import { GlobalContext } from '../../utils/globalContext';
import { CifHelpModal } from './cifHelpModal';

export const RegistryForm = ({ isEdit = false, initialValues }) => {
  const { setUser, setMenuKeys } = useContext(GlobalContext);
  const [form] = Form.useForm();
  const [loader, setLoader] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const [CFDIuse, setCFDIuse] = useState([]);
  const [tipoPersona, setTipoPersona] = useState(isEdit ? initialValues?.clie_tipo : 1); // Estado inicial, por defecto Persona Física (1)
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [campoActivo, setCampoActivo] = useState(null);
  const navigate = useNavigate();

  const renderLabelWithHelp = (label, fieldKey) => (
    <span>
      {label}{' '}
      <QuestionCircleOutlined
        className="icono-ayuda-input"
        onClick={(e) => {
          e.stopPropagation();
          setCampoActivo(fieldKey);
          setIsModalOpen(true);
        }}
      />
    </span>
  );

  const handleTipoChange = (value) => {
    setTipoPersona(value);
  };
  const updateUserInContext = (newValues) => {
    if (isEdit) {
      sessionStorage.setItem(sessionStorageKey_session, JSON.stringify(newValues));
      setUser(newValues);
    }
  };

  const onFinish = async (values) => {
    setLoader(true);
    const processedValues = { ...values };
    if (tipoPersona === 2 && processedValues.clie_nombre) {
      processedValues.clie_nombre = cleanBusinessNameSuffixes(processedValues.clie_nombre);
    }

    try {
      const responseInsertUser = await axios({
        method: isEdit ? 'PUT' : 'POST',
        url: `${apiBasePath}/customer`,
        data: {
          clie_activo: 1,
          clie_id: isEdit ? initialValues.clie_id : null,
          ...processedValues,
          clie_tel: processedValues.clie_tel ? processedValues.clie_tel : null,
          clie_password: processedValues.clie_rfc,
          clie_colonia_id: 0
        }
      });
      isEdit && updateUserInContext(responseInsertUser.data.customer);
      await messageApi.open({
        type: 'success',
        content: isEdit ? 'Actualización exitosa' : 'Registro exitoso'
      });
      isEdit ? navigate('/') : navigate('/login');
    } catch (error) {
      const messageError = error.response?.data?.message;
      const msgshowError = messageError
        ? messageError
        : isEdit
          ? 'Tuvimos problemas al actualizar tu cuenta'
          : 'Tuvimos problemas al registrar tu cuenta';
      messageApi.open({
        type: 'error',
        content: msgshowError,
        description: 'Por favor, intenta de nuevo'
      });
    } finally {
      setLoader(false);
    }
  };
  const getCFDIuser = async () => {
    try {
      const response = await axios.get(`${apiBasePath}/reference-data/tax-regime`);
      const useCFDI = response.data?.taxRegime?.data || [];
      setCFDIuse(useCFDI);
    } catch (error) {
      console.error('🚀 ~ getCFDIuser ~ error:', error);
    }
  };

  useEffect(() => {
    if (isEdit) {
      form.setFieldsValue(initialValues);
    }
    getCFDIuser();
  }, [initialValues?.clie_tipo]);

  return (
    <div className={isEdit ? 'my-profile-container' : 'login-container'}>
      {contextHolder}
      <Flex className="register-form-container">
        {!isEdit && <img src={`${process.env.PUBLIC_URL}/logoBdi.jpg`} alt="BDI Parking logo" className="login-logo" />}
        <Form
          name="login-register"
          form={form}
          layout="vertical"
          size="small"
          onFinish={withTrimmedForm(onFinish)}
          autoComplete="off"
          className="login-register-form">
          <div className="register-inputs-container">
            <Row gutter={16}>
              <Col xs={24} md={12}>
                <Form.Item
                  name="clie_tipo"
                  label="Tipo de persona"
                  rules={[{ required: true, message: 'Por favor ingresa el tipo de persona' }]}>
                  <Select onChange={handleTipoChange}>
                    <Select.Option value={1}>Persona Física</Select.Option>
                    <Select.Option value={2}>Persona Moral</Select.Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  name="clie_nombre"
                  label={tipoPersona === 1 ? 'Nombre' : renderLabelWithHelp('Razón social', 'razon_social')}
                  onKeyUp={(e) => valueToUpperCase(e.target.value, form, 'clie_nombre')}
                  rules={[{ required: true, message: 'Por favor ingresa tu nombre' }]}>
                  <Input />
                </Form.Item>
              </Col>
            </Row>
            {tipoPersona === 1 && (
              <Row gutter={16}>
                <Col xs={24} md={12}>
                  <Form.Item
                    name="clie_ap"
                    label="Apellido paterno"
                    onKeyUp={(e) => valueToUpperCase(e.target.value, form, 'clie_ap')}
                    rules={[{ required: true, message: 'Por favor ingresa tu apellidos paterno' }]}>
                    <Input />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item
                    name="clie_am"
                    label="Apellido materno"
                    onKeyUp={(e) => valueToUpperCase(e.target.value, form, 'clie_am')}
                    rules={[{ required: true, message: 'Por favor ingresa tu apellido materno' }]}>
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
            )}
            {/* <Row gutter={16}>
            <Col span={8}>
              <Form.Item
                name="clie_estado"
                label="Estado"
                rules={[{ required: true, message: 'Por favor ingresa tu estado' }]}>
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="clie_colonia"
                label="Colonia"
                rules={[{ required: true, message: 'Por favor ingresa tu colonia' }]}>
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="clie_delegacion"
                label="Delegación"
                rules={[{ required: true, message: 'Por favor ingresa tu delegación' }]}>
                <Input />
              </Form.Item>
            </Col>
          </Row> */}
            <Row gutter={16}>
              <Col xs={24} md={12}>
                <Form.Item
                  name="clie_cp"
                  label={renderLabelWithHelp('Código Postal', 'codigo_postal')}
                  onKeyDown={(e) => allowOnlyNumbers(e, true)}
                  rules={[
                    { required: true, message: 'Por favor ingresa tu codigo postal' },
                    {
                      max: 5,
                      min: 5,
                      message: 'Por favor ingresa un Código Postal valido'
                    }
                  ]}>
                  <Input />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  name="clie_tel"
                  label="Teléfono"
                  onKeyDown={(e) => allowOnlyNumbers(e, true)}
                  rules={[
                    {
                      min: 10,
                      message: 'Por favor ingresa un teléfono valido'
                    }
                  ]}>
                  <Input />
                </Form.Item>
              </Col>
              {/* <Col span={18}>
              <Form.Item
                name="clie_direccion"
                label="Dirección"
                rules={[{ required: true, message: 'Por favor ingresa tu dirección' }]}>
                <Input />
              </Form.Item>
            </Col> */}
            </Row>
            <Row gutter={16}>
              <Col xs={24} md={12}>
                <Form.Item
                  name="clie_rfc"
                  label={renderLabelWithHelp('RFC', 'rfc')}
                  onKeyUp={(e) => valueToUpperCase(e.target.value, form, 'clie_rfc')}
                  rules={[
                    { required: true, message: 'Por favor ingresa tu RFC' },
                    {
                      max: 13,
                      message: 'Por favor ingresa un RFC valido'
                    }
                  ]}>
                  <Input />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  name="clie_regimen_fiscal"
                  label={renderLabelWithHelp('Régimen Fiscal', 'regimen_fiscal')}
                  rules={[{ required: true, message: 'Por favor ingresa tu regimen fiscal' }]}>
                  <Select
                    showSearch
                    filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}>
                    {CFDIuse.map((item) => (
                      <Select.Option
                        key={`cfdi-${item.id}`}
                        value={item.code}
                        label={`${item.code}-${item.description}`}>
                        {`${item.code}-${item.description}`}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={24}>
                <Form.Item
                  name="clie_correo"
                  label="Correo electrónico"
                  rules={[
                    { required: true, message: 'Por favor ingresa tu correo electrónico' },
                    { type: 'email', message: 'Por favor ingresa un correo electrónico valido' }
                  ]}>
                  <Input />
                </Form.Item>
              </Col>
            </Row>

            {/* <Row gutter={16}>
              <Col xs={24} md={12}>
                <Form.Item
                  name="password"
                  label="Contraseña"
                  rules={[{ required: true, message: 'Por favor ingresa tu contraseña' }]}>
                  <Input.Password />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  name="clie_password"
                  label="Confirmar Contraseña"
                  dependencies={['password']}
                  hasFeedback
                  rules={[
                    {
                      required: true,
                      message: 'Por favor confirma tu contraseña'
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue('password') === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(new Error('Las contraseñas no coinciden'));
                      }
                    })
                  ]}>
                  <Input.Password />
                </Form.Item>
              </Col>
            </Row> */}
          </div>
          <Flex justify="flex-end" align="center" gap={24} className="login-form-buttons">
            {!isEdit ? (
              <Button
                type="default"
                icon={<ArrowLeftOutlined />}
                htmlType="reset"
                className="login-back-button"
                size="large"
                onClick={() => {
                  form.resetFields();
                  navigate('/login');
                }}>
                Regresar
              </Button>
            ) : (
              <Button
                type="default"
                icon={<ArrowLeftOutlined />}
                htmlType="reset"
                className="login-back-button"
                size="large"
                onClick={() => {
                  navigate('/');
                  setMenuKeys([]);
                }}>
                Cancelar
              </Button>
            )}
            <Button
              type="primary"
              className="login-back-button"
              size="large"
              loading={loader}
              onClick={() => {
                form.submit();
              }}>
              Guardar
            </Button>
          </Flex>
        </Form>
      </Flex>
      <CifHelpModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        campoActivo={campoActivo}
      />
    </div>
  );
};
